window.addEventListener('load', function () {
  document.querySelectorAll('.p-footer-table-wrap, .is-scrollable, .wp-block-table').forEach(function(el) {

    if (el.scrollWidth > el.clientWidth) {
      new ScrollHint(el, {
        i18n: {
                scrollable: "スクロールできます"
              },
        showText: true
      });
    }

  });
});
